<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-hamburger"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Restaurant v2</span></li>
                <li><span class="text-muted">Productos por área</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <button class="btn btn-custom btn-sm mt-2 mr-2" @click.prevent="clickCreate()">
                    <i class="fa fa-plus-circle"></i> Nuevo
                </button>
            </div>
        </div>

        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Configuración de productos por área</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Código</th>
                                <th>Producto</th>
                                <th>Área</th>
                                <th>Comanda</th>
                                <th>Estado</th>
                                <th class="text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in records" :key="row.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ row.item ? row.item.internal_id : '' }}</td>
                                <td>{{ row.item ? row.item.description : '' }}</td>
                                <td>{{ row.production_area ? row.production_area.name : '' }}</td>
                                <td>
                                    <el-tag :type="row.print_on_kitchen ? 'success' : 'info'">
                                        {{ row.print_on_kitchen ? 'Sí imprime' : 'No imprime' }}
                                    </el-tag>
                                </td>
                                <td>
                                    <el-tag :type="row.active ? 'success' : 'info'">
                                        {{ row.active ? 'Activo' : 'Inactivo' }}
                                    </el-tag>
                                </td>
                                <td class="text-right">
                                    <button class="btn btn-xs btn-info" @click.prevent="clickCreate(row)">
                                        Editar
                                    </button>
                                    <button class="btn btn-xs btn-danger" @click.prevent="clickDelete(row.id)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <item-setting-form
            :showDialog.sync="showDialog"
            :record="record"
            @saved="getRecords">
        </item-setting-form>
    </div>
</template>

<script>
import { deletable } from '@mixins/deletable'
import ItemSettingForm from './form.vue'

export default {
    mixins: [deletable],
    components: { ItemSettingForm },
    data() {
        return {
            resource: 'restaurant/v2/item-settings',
            records: [],
            showDialog: false,
            record: null,
        }
    },
    created() {
        this.getRecords()
    },
    methods: {
        getRecords() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data
            })
        },
        clickCreate(record = null) {
            this.record = record
            this.showDialog = true
        },
        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`).then(() => this.getRecords())
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/item_settings/index.vue